import "bootstrap/dist/css/bootstrap.min.css";
import "../../../public/css/hcpay/app.css";
import "./bootstrap.js";
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import Vuelidate from "vuelidate";
import VuePusher from 'vue-pusher';
Vue.use(Vuelidate);

Vue.use(VuePusher, {
  api_key: import.meta.env.VITE_PUSHER_APP_KEY,
  options: {
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  },
});

Vue.component("pulse-loader", PulseLoader);

// Vue.prototype.$socket = {
//     sseClient: null,
//     connect(tid, callback) {
//         if(!this.sseClient) {
//             this.sseClient = new EventSource("sse/notification/connect?tid="+tid);
//         }

//         if(callback) {
//             callback()
//         };
//     },
//     disconnect() {
//         if (this.sseClient) {
//             this.sseClient.close();
//             this.sseClient = null;
//         }
//     },
//     subscribe(callback) {
//         if(this.sseClient) {
//             this.sseClient.addEventListener("PAYMENT_UPDATE", (event) => {
//                 let data = JSON.parse(event.data);
//                 try {
//                     if (callback) callback(data);
//                     if(data.hasOwnProperty('status') && data.status === 'SUCCESS'){
//                         this.disconnect();
//                     }
//                 } catch (e) {
//                     console.error("Invalid SSE message", data);
//                 }
//             });  
//         }
//     }
// };

import "./stores.js";
import "./views.js";
import "./components.js";
import "./modals.js";
import { ERROR } from "./mixins/error_codes.js";
import { getJSON } from "jquery";
import { isMobile, isTablet, isBrowser } from "mobile-device-detect";
import axios from "axios";
import Fingerprint2 from 'fingerprintjs2';

const app = new Vue({
    data: {
        transaction: transaction,
        account: {
            username: "09900000000",
            type: "FCBK",
        },
        tid: null,
        view: view,
        previousView: null,
        error: null,
        //mobapp_id: mobile_app_id,
        complete: false,
        userDevice: "",
        isAndroid: /(android)/i.test(navigator.userAgent),
        statistics: {
            fpcrumb: null,
            eccrumb: null,
        },
        analyticsData: {
            userAgent: parser.getUA(),
            phone: parser.getDevice().model,
            operatingSystem: {
                name: parser.getOS().name,
                version: parser.getOS().version,
            },
            browser: {
                name: parser.getBrowser().name,
                version: parser.getBrowser().version,
            },
        },
        paymentOption: null,
        sessionPage: "session-expired-back-to-store",
        urlSession: "",
        // openFabric: ['HCPH2023000071113','HCPH2023000071153'],
    },
    created() {
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        this.tid = params.get("tid");
        let vm = this;
        if (this.transaction.partnerId) {
            this.sessionPage = "session-expired-back-to-merchant-paynamics";
            this.urlSession = vm.$root.transaction.cancelURL;
        } else {
            this.sessionPage = "session-expired-back-to-merchant";
            this.urlSession = vm.$root.transaction.failedUrl;
        }
        if (
            this.transaction.status == "CANCELLED" ||
            this.transaction.status == "CANCELLED_NON_ELIGIBLE" ||
            this.transaction.status == "REFUNDED" ||
            this.transaction.status == "SUCCESS"
        ) {
            vm.$dialog
                .alert("", {
                    view: this.sessionPage,
                    html: true,
                    customClass: "dialog-sm",
                })
                .then(() => {
                    window.location.href = this.urlSession;
                });
        }

        //check if device is mobile or desktop
        if (isMobile || isTablet) {
            this.userDevice = "Mobile";
            this.deviceChecker(this.userDevice);
        } else {
            this.userDevice = "Desktop";
            this.deviceChecker(this.userDevice);
        }

        if (window.requestIdleCallback) {
            requestIdleCallback(function () {
                Fingerprint2.get(function (components) {
                    vm.statistics.fpcrumb = components;
                });
            });
        } else {
            setTimeout(function () {
                Fingerprint2.get(function (components) {
                    vm.statistics.fpcrumb = components;
                });
            }, 10000);
        }
        window.addEventListener("evercookie", function (e) {
            vm.statistics.eccrumb = e.detail;
        });

        document.onmousemove = this.resetIdleTimer;
        document.onkeypress = this.resetIdleTimer;

        if (vm.$root.transaction.paymentRequestId) {
            if (vm.$root.transaction.isOpg2) {
                this.$root.$data.view = "opg-verify-identity";
            } else {
                this.$root.$data.view = "verify-identity";
            }
        }
    },
    methods: {
        showLoader() {
            this.$dialog.confirm(
                "Wait a moment while we load this for you...",
                {
                    view: "loader",
                    html: true,
                    loader: true,
                    waitForResult: false,
                }
            );
        },
        logEvent(elapsed, event) {
            elapsed = (Date.now() - elapsed) / 1000;
            axios
                .post("log_event?tid=" + this.tid, {
                    event: event,
                    elapsed: elapsed,
                })
                .then((response) => {})
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.reload(true);
                    }
                });
        },
        triggerG4Event(name, params = {}) {
            if (typeof gtag === "function") {
                gtag("event", name, params);
            } else {
                console.log("GTAG Func Not Defined");
            }
        },
        async deviceChecker(deviceSource) {
            try {
                const response = await axios.post(
                    "opg/check-device?tid=" +
                        this.tid +
                        "&deviceSource=" +
                        deviceSource
                );
            } catch (error) {
                this.$root.error = error.response.data.message;
            }
        },
    },
    watch: {
        error: {
            handler: function (error) {
                let vm = this;
                if (transaction != "lazada") {
                    let errorPage = {
                        [ERROR.PAYMENT_OPTION_UNAVAILABLE]: () =>
                            (vm.view = "not-available"),
                        [ERROR.HOMECREDIT_ACCOUNT_UNAVAILABLE]: () =>
                            (vm.view = "not-available"),
                        [ERROR.TECHNICAL_PROBLEM]: () => {
                            vm.$dialog.alert("", {
                                view: "technical-error",
                                html: true,
                                customClass: "dialog-sm",
                            });
                        },
                    };
                    if (error in errorPage) {
                        errorPage[error]();
                    } else if (error == "TECHNICAL_PROBLEM") {
                        errorPage[ERROR.TECHNICAL_PROBLEM]();
                    } else {
                        if (
                            this.$root.$data.transaction.hasOwnProperty(
                                "isOpg2"
                            ) &&
                            this.$root.$data.transaction.isOpg2
                        ) {
                            this.$root.$data.view = "generic-error-opg2";
                        } else {
                            this.$root.$data.view = "generic-error";
                        }
                    }
                }
            },
        },
        statistics: {
            handler() {
                let vm = this;
                if (this.$root.transaction.page != "lazada") {
                    //if all properties are not null and has value
                    if (
                        !Object.values(this.statistics).some(
                            (statistic) => statistic == null
                        )
                    ) {
                        axios
                            .post(
                                "hcpay/store_device_data?tid=" + this.tid,
                                this.statistics
                            )
                            .then((response) => {})
                            .catch((error) => {
                                vm.error = ERROR.TECHNICAL_PROBLEM;
                            });
                    }
                }
            },
            deep: true,
        },
    },
}).$mount("#app");
